import { useEffect, useState } from "react";
import Api from "../openapi";
import { IngredientResponse } from "../openapi/client";

export default function useIngredients() {
  const [ingredients, setIngredients] = useState<IngredientResponse[]>([]);

  useEffect(() => {
    const getIngredients = async () => {
      try {
        const res = await Api.Ingredients.listIngredients();
        setIngredients(res.data);
      } catch (error) {}
    };
    getIngredients();
  }, []);
  return ingredients;
}
